import { Producer } from "../types";

export const producerDisplayTextMap: Record<Producer, string> = {
    [Producer.ESSILOR]: 'Essilor',
    [Producer.SHAMIR]: 'Shamir'
}

export const catalogVariantDisplayTextMap: Record<string, string> = {
    magazin: 'Magazynowe',
    prescription: 'Recepturowe',
    ST: 'ST',
    RX: 'RX'
}